/**
 * @generated SignedSource<<218f1184e1a29661766dd1b592a964e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PublishDialog_canCreateAnnouncement_Query$variables = {
  spaceId: string;
};
export type PublishDialog_canCreateAnnouncement_Query$data = {
  readonly space: {
    readonly modules?: ReadonlyArray<{
      readonly canCreateAnnouncement?: {
        readonly value: boolean;
      };
    }>;
  } | null;
};
export type PublishDialog_canCreateAnnouncement_Query = {
  response: PublishDialog_canCreateAnnouncement_Query$data;
  variables: PublishDialog_canCreateAnnouncement_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "spaceId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canCreateAnnouncement",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SpaceAnnouncementsModule",
  "abstractKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PublishDialog_canCreateAnnouncement_Query",
    "selections": [
      {
        "alias": "space",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Space",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PublishDialog_canCreateAnnouncement_Query",
    "selections": [
      {
        "alias": "space",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Space",
            "abstractKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ec53696a4017f1688c26bb0949a002f9",
    "id": null,
    "metadata": {},
    "name": "PublishDialog_canCreateAnnouncement_Query",
    "operationKind": "query",
    "text": "query PublishDialog_canCreateAnnouncement_Query(\n  $spaceId: ID!\n) {\n  space: node(id: $spaceId) {\n    __typename\n    ... on Space {\n      modules {\n        __typename\n        ... on SpaceAnnouncementsModule {\n          canCreateAnnouncement {\n            value\n          }\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "05ea1bcc6fd82ff1709802077f1a1fa9";

export default node;
